import { G } from '@mobily/ts-belt';

import { CampaignSampleEmployees } from '@Common/types/bo/b2b/campaigns';

import { DownloadOperationsFileSample } from '@sh4res/bo-common/components/B2bCampaigns/DownloadSample';
import { B2bCampaignFormValues } from '@sh4res/bo-common/components/B2bCampaigns/types';
import { useWatchObject } from '@sh4res/bo-common/hooks';

const sampleOptions: { employees: CampaignSampleEmployees; label: string }[] = [
  {
    employees: 'none',
    label: 'resources.bo_common.b2b.campaigns.sections.allocations.download_sample_empty',
  },
  {
    employees: 'current',
    label:
      'resources.bo_common.b2b.campaigns.sections.allocations.download_sample_current_employees',
  },
  {
    employees: 'all',
    label: 'resources.bo_common.b2b.campaigns.sections.allocations.download_sample_all_employees',
  },
];

export const DownloadAllocationSampleOptions = () => {
  const {
    amount_type_input: amountType,
    company_id: companyId,
    type: campaignType,
    choice_collected_by: choiceCollectedBy,
    b2b_contract_ids: contractIds,
    matching_contribution_computed_by: matchingContributionComputedBy,
    matching_contribution_related_cash_source: matchingContributionRelatedCashSource,
  } = useWatchObject<B2bCampaignFormValues>()([
    'amount_type_input',
    'company_id',
    'type',
    'choice_collected_by',
    'b2b_contract_ids',
    'matching_contribution_computed_by',
    'matching_contribution_related_cash_source',
  ]);

  if (!amountType || !choiceCollectedBy || G.isNullable(companyId)) {
    return null;
  }

  return (
    <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
      {sampleOptions.map(({ employees, label }) => (
        <li key={employees} style={{ margin: 0, padding: 0 }}>
          <DownloadOperationsFileSample
            label={label}
            body={{
              kind: 'campaign_sample',
              variant: 'allocations',
              company_id: companyId,
              contract_ids: contractIds,
              employees,
              campaign_type: campaignType,
              amount_type: amountType,
              choice_collected_by: choiceCollectedBy,
              matching_contribution_computed_by: matchingContributionComputedBy ?? null,
              matching_contribution_related_cash_source:
                matchingContributionRelatedCashSource ?? null,
            }}
          />
        </li>
      ))}
    </ul>
  );
};
